(() => {
  try {
      // Keep module and structured-data scripts intact on every platform.
      // Do not remove script sources based on browser or platform fingerprints.
      // Event Listener Management
      var _listeners = [];
      EventTarget.prototype.addEventListenerBase = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function (e, t, p) {
        _listeners.push({ target: this, type: e, listener: t });
        this.addEventListenerBase(e, t, p);
      };
      EventTarget.prototype.removeEventListeners = function (e) {
        for (var t = 0; t != _listeners.length; t++) {
          var r = _listeners[t],
            n = r.target,
            s = r.type,
            i = r.listener;
          if (n == this && s == e) {
            this.removeEventListener(s, i);
          }
        }
      };
      
      // MutationObserver to modify script types
      const scriptobserver = new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => {
          addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.tagName === "SCRIPT") {
              if (
                node.innerHTML && ( node.innerHTML.includes("facebook") ||  node.innerHTML.includes("loox"))
                // node.innerHTML && node.innerHTML.includes("facebook") 
                // node.innerHTML &&  node.innerHTML.includes("loox")
              ) {
                // Do not defer Facebook scripts; skip processing this node
                // No action needed for critical scripts
              } else {
                // Proceed with deferring non-critical scripts
                if (node.innerHTML && node.innerHTML.includes("asyncLoad")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("hotjar")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("clarity")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("xklaviyo")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("klaviyo")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("recaptcha")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("signup")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("tiktok")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("tiktokv")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("pinterest")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("klaviyo")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("signup")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("loox")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("shop.app")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("chat")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("judge.me")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("gorgias")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("gorgias")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("stripe")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("mem")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("privy")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("incart")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("webui")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("gtag")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("tagmanager")) {
                  node.type = "text/spdnscript";
                } else if (node.innerHTML && node.innerHTML.includes("gtm")) {
                  node.type = "text/spdnscript";
                } else if (node.src && node.src.includes("googlet")) {
                  node.type = "text/spdnscript";
                } else if (node.className == "analytics") {
                  node.type = "text/spdnscript";
                }
              }
            }
          });
        });
      });

      
      // Updated browser detection and condition
      var ua = navigator.userAgent.toLowerCase();
      var isChrome =
        ua.indexOf("chrome") > -1 &&
        ua.indexOf("edge") === -1 &&
        ua.indexOf("edg") === -1;
      var isFirefox = ua.indexOf("firefox") > -1;
      var isSafari =
        ua.indexOf("safari") > -1 &&
        ua.indexOf("chrome") === -1 &&
        ua.indexOf("crios") === -1 &&
        ua.indexOf("fxios") === -1;
      var isEdge = ua.indexOf("edge") > -1 || ua.indexOf("edg") > -1;
      var isFacebookBrowser =
        ua.indexOf("fbav") > -1 ||
        ua.indexOf("fbios") > -1 ||
        ua.indexOf("fb_iab") > -1 ||
        ua.indexOf("fban") > -1 ||
        ua.indexOf("facebook") > -1;
      var noOptimization = window.location.href.indexOf("no-optimization") > -1;
      var isCartPage = window.location.href.indexOf("cart") > -1;
      
      if (
        (isChrome || isFirefox || isSafari || isEdge || isFacebookBrowser) &&
        !noOptimization &&
        !isCartPage
      ) {
        scriptobserver.observe(document.documentElement, { childList: true, subtree: true });
      }
      
      // Integrated code to handle deferred script execution
      const spdn_t = ["mouseover", "keydown", "touchmove", "touchstart", "wheel"];
      var perfEntries = performance.getEntriesByType("navigation");
      
      function e() {
        scriptobserver.disconnect();
        ev();
        spdn_t.forEach(function (spdnt) {
          window.removeEventListener(spdnt, e, { passive: true });
        });
        n();
      }
      
      function seq(t, e, n) {
        if (!Array.isArray(t) || t.length === 0) {
          e();
          return;
        }
        if (n === undefined) n = 0;
        if (n >= t.length) {
          e();
          return;
        }
        if (typeof t[n] === 'function') {
          t[n](function () {
            seq(t, e, n + 1);
          });
        } else {
          e();
        }
      }
      
      
      function u() {
        if (perfEntries[0]["loadEventEnd"] > 0) {
          var t = document.createEvent("Event");
          t.initEvent("DOMContentLoaded", true, true);
          window.dispatchEvent(t);
          document.dispatchEvent(t);
          var e = document.createEvent("Event");
          e.initEvent("readystatechange", true, true);
          window.dispatchEvent(e);
          document.dispatchEvent(e);
          var n = document.createEvent("Event");
          n.initEvent("load", true, true);
          window.dispatchEvent(n);
          document.dispatchEvent(n);
          var i = document.createEvent("Event");
          i.initEvent("show", true, true);
          window.dispatchEvent(i);
          document.dispatchEvent(i);
          var c = window.document.createEvent("UIEvents");
          c.initUIEvent("resize", true, true, window, 0);
          window.dispatchEvent(c);
          document.dispatchEvent(c);
        }
      }
      
      function spdni(t, e) {
        var n = document.createElement("script");
        n.type = "text/javascript";
        if (t.src) {
          n.onload = e;
          n.onerror = e;
          n.src = t.src;
          n.id = t.id;
          n.async = false;
          Object.assign(n.dataset, t.dataset);
        } else {
          n.textContent = t.innerText;
          n.id = t.id;
          n.async = false;
          Object.assign(n.dataset, t.dataset);
        }
        t.parentNode.removeChild(t);
        document.body.appendChild(n);
        if (!t.src) e();
      }
      
      function n() {
        var t = document.querySelectorAll("script"),
          e = [];
        [].forEach.call(t, function (t) {
          if (t.getAttribute("type") == "text/spdnscript") {
            e.push(function (e) {
              spdni(t, e);
            });
          }
        });
        if (e.length > 0) {
          seq(e, u);
        } else {
          u();
        }
      }
      
      
      function ev() {
        if (
          perfEntries[0]["loadEventEnd"] > 0 &&
          typeof document.removeEventListeners !== "undefined"
        ) {
          console.log("ev=1");
          document.removeEventListeners("DOMContentLoaded");
          document.removeEventListeners("load");
        }
      }
      
      spdn_t.forEach(function (t) {
        window.addEventListener(t, e, { passive: true });
      });

      // Helper function to select elements
      var querySelector = (selector) => document.querySelector(selector),
          startTime = Date.now(),
          moveElementsToHead = () => {
              // Stop trying after 500ms
              if (Date.now() - startTime > 500) {
                  return;
              }
              // If no <meta> element is found in the body, retry after 5ms
              if (!querySelector("body > meta")) {
                  return setTimeout(moveElementsToHead, 5);
              }
              // Move <meta>, <link> (excluding stylesheets), and <title> elements to the <head>
              var headElement = querySelector("head");
              document
                  .querySelectorAll("meta, link:not([rel='stylesheet']), title")
                  .forEach((elem) => headElement.append(elem));
          };
      moveElementsToHead(); // Start the process
  } catch (error) {
      // Silently catch and ignore errors
  }
})();
